import orderAxiosInstance from './api';
import {
    BatchReturnProcessingSummary,
    BatchReturnProcessingResult,
} from 'types/batchReturnProcessing';

export const batchReturnProcessingService = {
    getProcessingSummary: async (batchReturnId: number): Promise<BatchReturnProcessingSummary> => {
        const response = await orderAxiosInstance.get<BatchReturnProcessingSummary>(
            `/api/return/batch/${batchReturnId}/processing`,
        );
        return response.data;
    },

    processReturns: async (batchReturnId: number, returnIds: number[]): Promise<BatchReturnProcessingResult> => {
        const response = await orderAxiosInstance.post<BatchReturnProcessingResult>(
            `/api/return/batch/${batchReturnId}/processing`,
            { returnIds },
        );
        return response.data;
    },
};
